<template>
	<v-app>
		<v-main>
			<v-row style="height: calc(100vh - 58px);" class="d-flex justify-center align-center">
				<v-col class="text-center">
					<!-- <h1 class="display-2 primary--text">Whoops!, 404</h1> -->
					<h1 class="display-2 primary--text mb-5">Something Went Wrong</h1>

					<p class="mb-5">The page you are looking for does not exist</p>

					<p class="mt-5" style="font-size: 10px; font-weight: bold;">If this issue persists please contact us through our email with a screenshot at <span 
					style="color:blue; text-decoration: underline;">support@v-unite.com</span></p>

					<v-btn
						@click="action"
						color="primary"
						outlined
					>Get me out of here!</v-btn>
				</v-col>
			</v-row>
		</v-main>
	</v-app>
</template>

<script>
export default {
	name: "FourOhFour",
	methods: {
		action() {
			this.$router.back();
		}
	}
};
</script>